/**
 * How It Works Page — sections & items
 * Future: fetched from Supabase
 */

const howItWorksPage = {
  seo: {
    title: "Comment ça marche",
    description: "Découvrez les étapes simples pour commander votre bijou en résine personnalisé chez Sublime Résine. De la sélection à la réception, tout est fait avec soin au Québec.",
    path: "/comment-ca-marche",
  },
  sections: [
    {
      id: "how_hero",
      type: "page_header",
      isActive: true,
      sortOrder: 1,
      data: {
        title: "Comment ça marche",
        subtitle: "De la sélection de votre bijou à sa réception, découvrez chaque étape du processus pour obtenir votre création personnalisée en résine.",
      },
    },
    {
      id: "how_steps",
      type: "timeline",
      isActive: true,
      sortOrder: 2,
      items: [
        { id: "how_step_1", icon: "search", stepLabel: "Étape 1", title: "Explorez nos collections", desc: "Parcourez notre catalogue de bijoux en résine : boucles d'oreilles, colliers, médailles, breloques, porte-clés et plus encore. Chaque création peut être personnalisée selon vos envies.", tip: "Consultez chaque collection pour voir les modèles disponibles et les prix.", isActive: true, sortOrder: 1 },
        { id: "how_step_2", icon: "palette", stepLabel: "Étape 2", title: "Choisissez vos personnalisations", desc: "Décidez des détails qui rendront votre bijou unique : couleurs de résine, ajout de brillants, paillettes, fleurs séchées, et surtout l'inclusion de photos ou de poils de votre compagnon.", tip: "Toutes les combinaisons sont possibles — laissez libre cours à votre imagination.", isActive: true, sortOrder: 2 },
        { id: "how_step_3", icon: "send", stepLabel: "Étape 3", title: "Remplissez le formulaire", desc: "Rendez-vous sur notre page Commander et remplissez le formulaire avec vos choix : type de bijou, collection, personnalisations souhaitées, et toute information utile sur votre animal.", tip: "Vous pouvez aussi nous envoyer un message via Messenger pour discuter de votre projet.", isActive: true, sortOrder: 3 },
        { id: "how_step_4", icon: "mail", stepLabel: "Étape 4", title: "Envoyez vos éléments", desc: "Si vous avez choisi l'option photo, envoyez-nous une image de bonne qualité de votre animal. Pour l'option poils, nous vous donnerons les instructions d'envoi postal après confirmation.", tip: "Une petite pincée de poils propres et secs suffit — envoyez-les dans une enveloppe.", isActive: true, sortOrder: 4 },
        { id: "how_step_5", icon: "scissors", stepLabel: "Étape 5", title: "Fabrication artisanale", desc: "Votre bijou est fabriqué entièrement à la main dans notre atelier au Québec. Chaque pièce demande du temps et de l'attention pour un résultat parfait. Comptez 2 à 3 semaines de délai.", tip: "Nous vous tiendrons informé de l'avancement de votre commande.", isActive: true, sortOrder: 5 },
        { id: "how_step_6", icon: "package", stepLabel: "Étape 6", title: "Réception de votre bijou", desc: "Votre création est soigneusement emballée et expédiée par Poste Canada. Vous recevrez un numéro de suivi pour suivre votre colis jusqu'à votre porte.", tip: "Livraison partout au Canada pour seulement 5 $.", isActive: true, sortOrder: 6 },
      ],
    },
    {
      id: "how_supplements",
      type: "supplements_grid",
      isActive: true,
      sortOrder: 3,
      data: {
        title: "Options et suppléments",
      },
      // items: pulled from siteSettings.supplements automatically
    },
    {
      id: "how_personalization",
      type: "quote_block",
      isActive: true,
      sortOrder: 4,
      data: {
        icon: "palette",
        text: "Toutes les créations sont personnalisables selon vos envies : couleurs, brillants, éléments intégrés et détails du design.",
      },
    },
    {
      id: "how_cta",
      type: "cta_banner",
      isActive: true,
      sortOrder: 5,
      data: {
        title: "Prêt à commencer ?",
        subtitle: "Explorez nos collections ou passez directement votre commande.",
        cta1: { label: "Voir les collections", href: "/bijoux" },
        cta2: { label: "Commander maintenant", href: "/commander" },
      },
    },
  ],
};

export default howItWorksPage;
